module.exports = __webpack_public_path__ + "static/media/spa-secondary.4f93f4d7.jpg";